import { useState, useEffect } from "react";
import api from "../../services/api";
import DataTable from "react-data-table-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil } from "@fortawesome/free-solid-svg-icons";
import { faSquarePlus } from "@fortawesome/free-solid-svg-icons";
import { faSquareMinus } from "@fortawesome/free-solid-svg-icons";
import Swal from "sweetalert2";
import EditModal from "../ui/EditModal.js";
import { normalizar } from "../../common/stringNormalizer.js";

const AddDiagnostico = () => {
  const [filtroEstado, setFiltroEstado] = useState("activas");
  const [Nombre, setNombre] = useState("");
  const [Descripcion, setDescripcion] = useState("");
  const [Diagnosticos, setDiagnosticos] = useState([]);
  const [mostrarDescripcion, setMostrarDescripcion] = useState({});
  const [selectedDiagnostico, setSelectedDiagnostico] = useState(null);

  useEffect(() => {
    getDiagnosticos();
  }, []);

  const editFields = [
    { name: "Nombre", label: "Nombre Diagnostico", type: "text", required: true },
    { name: "Descripcion", label: "Descripcion Diagnostico", type: "text", required: false }
  ];

  const getDiagnosticos = async () => {
    const response = await api.get(`/diagnosticos`);
    setDiagnosticos(response.data);
  };

  const createDiagnostico = async (e) => {
    e.preventDefault();

    const existe = Diagnosticos.some(
      (diagnostico) => normalizar(diagnostico.Nombre) === normalizar(Nombre)
    );

    if (existe) {
      Swal.fire({
        icon: "warning",
        title: "Duplicado",
        text: "Ya existe un diagnostico con ese nombre.",
        confirmButtonColor: "#3085d6"
      });
      return;
    }

    try {
      await api.post(`/diagnosticos`, {
        Nombre,
        Descripcion,
      });
      getDiagnosticos();
      setNombre("");
      setDescripcion("");
      Swal.fire({
        icon: "success",
        title: "Guardado",
        text: "El diagnostico fue guardado exitosamente.",
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.log(error);
      Swal.fire({
        icon: "error",
        title: "Error al guardar",
        text: "Ocurrio un problema al guardar el diagnostico.",
      });
    }
  };

  const handleEditDiagnostico = async (values) => {
    try {
      await api.put(`/diagnosticos/${values.IdDiagnostico}`, { Nombre: values.Nombre, Descripcion: values.Descripcion });
      Swal.fire({
        icon: "success",
        title: "Diagnostico actualizado",
        showConfirmButton: false,
        timer: 1500,
      });
    } catch (error) {
      console.error("Error al actualizar:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Ocurrio un error al actualizar el diagnostico.",
      });
    }
    setSelectedDiagnostico(null);
    getDiagnosticos();
  };

  const cambiarEstado = async (IdDiagnostico) => {
    try {
      const diagnosticoActual = Diagnosticos.find((d) => d.IdDiagnostico === IdDiagnostico);
      const nuevoEstado = diagnosticoActual.Estado === 1 ? "desactivado" : "activado";

      const response = await api.patch(`/diagnosticos/toggle/${IdDiagnostico}`);

      await getDiagnosticos();

      Swal.fire({
        icon: "success",
        title: `Diagnostico ${nuevoEstado}`,
        text: response.data?.msg || `El diagnostico fue ${nuevoEstado} correctamente.`,
        timer: 1500,
        showConfirmButton: false,
      });
    } catch (error) {
      console.error("Error al cambiar estado:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text:
          error.response?.data?.msg ||
          "Ocurrio un error al cambiar el estado del diagnostico.",
      });
    }
  };

  const filtrarDiagnosticos = () => {
    if (filtroEstado === "activas") return Diagnosticos.filter((d) => d.Estado === 1);
    if (filtroEstado === "inactivas") return Diagnosticos.filter((d) => d.Estado === 0);
    return Diagnosticos;
  };

  const columnas = [
    {
      name: "Nombre",
      selector: (row) => row.Nombre,
      sortable: true,
      width: "15vw",
    },
    {
      name: "Descripcion",
      cell: (row) => {
        const toggleDescripcion = () => {
          setMostrarDescripcion({
            ...mostrarDescripcion,
            [row.IdDiagnostico]: !mostrarDescripcion[row.IdDiagnostico],
          });
        };

        const descripcion = row.Descripcion || "Sin descripcion";
        const mostrarBoton = row.Descripcion && row.Descripcion.length > 40;

        const estiloCelda = {
          display: "flex",
          alignItems: "center",
          width: "30vw",
          maxHeight: mostrarDescripcion[row.IdDiagnostico] ? "none" : "40vh",
          overflow: mostrarDescripcion[row.IdDiagnostico] ? "visible" : "hidden",
        };

        const estiloContenido = {
          flex: 1,
          maxHeight: "40vh",
          textOverflow: mostrarDescripcion[row.IdDiagnostico] ? "clip" : "ellipsis",
          whiteSpace: mostrarDescripcion[row.IdDiagnostico] ? "normal" : "nowrap",
        };

        return (
          <div style={estiloCelda}>
            <div style={estiloContenido}>
              {!mostrarDescripcion[row.IdDiagnostico]
                ? descripcion.length > 40
                  ? descripcion.substring(0, 40) + "..."
                  : descripcion
                : descripcion}
            </div>
            {mostrarBoton && (
              <button
                className="btn"
                onClick={(e) => {
                  toggleDescripcion();
                  e.preventDefault();
                }}
              >
                {mostrarDescripcion[row.IdDiagnostico] ? "Ver Menos" : "Ver Mas"}
              </button>
            )}
          </div>
        );
      },
      sortable: true,
      width: "30vw",
    },
    {
      cell: (row) => (
        <button
          className="button is-small is-info"
          title="Editar"
          onClick={() => setSelectedDiagnostico(row)}
        >
          <FontAwesomeIcon icon={faPencil} />
        </button>
      ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
    {
      cell: (row) =>
        row.Estado === 1 ? (
          <FontAwesomeIcon
            icon={faSquarePlus}
            style={{ color: "#37ff00", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdDiagnostico)}
          />
        ) : (
          <FontAwesomeIcon
            icon={faSquareMinus}
            style={{ color: "#ff0000", cursor: "pointer" }}
            size="2xl"
            onClick={() => cambiarEstado(row.IdDiagnostico)}
          />
        ),
      ignoreRowClick: true,
      allowOverflow: true,
      button: true,
      compact: true,
    },
  ];

  const paginationOptionsES = {
    rowsPerPageText: "Filas por pagina",
    rangeSeparatorText: "de",
    selectAllRowsItem: true,
    selectAllRowsItemText: "Todos",
  };

  return (
    <div className="columns mt-5 is-centered">
      <div>
        <div className="notification is-primary">
          <strong>Ingresa el nombre del diagnostico.</strong>
        </div>
        <form onSubmit={createDiagnostico}>
          <div className="field">
            <div className="container">
              <label className="label required">Nombre Diagnostico</label>
              <div className="control">
                <input
                  type="text"
                  className="input"
                  value={Nombre}
                  onChange={(e) => setNombre(e.target.value)}
                  placeholder="Nombre"
                  required
                />
              </div>
            </div>
          </div>

          <div className="field">
            <div className="container">
              <label className="label">Descripcion Diagnostico</label>
              <div className="control">
                <textarea
                  className="textarea"
                  value={Descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  placeholder="Descripcion"
                />
              </div>
            </div>
          </div>

          <div className="field">
            <button className="button is-success" type="submit">
              Guardar
            </button>
          </div>

          <div className="field is-grouped mt-3">
            <p className="control">
              <button
                type="button"
                className={`button ${filtroEstado === "activas" ? "is-primary" : "is-light"}`}
                onClick={() => setFiltroEstado("activas")}
              >
                Activas
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button ${filtroEstado === "inactivas" ? "is-primary" : "is-light"}`}
                onClick={() => setFiltroEstado("inactivas")}
              >
                Inactivas
              </button>
            </p>
            <p className="control">
              <button
                type="button"
                className={`button ${filtroEstado === "todas" ? "is-primary" : "is-light"}`}
                onClick={() => setFiltroEstado("todas")}
              >
                Todas
              </button>
            </p>
          </div>

          <DataTable
            pagination
            paginationComponentOptions={paginationOptionsES}
            columns={columnas}
            data={filtrarDiagnosticos()}
          />
        </form>
      </div>

      {selectedDiagnostico && (
        <EditModal
          fields={editFields}
          initialValues={selectedDiagnostico}
          onSubmit={handleEditDiagnostico}
          onClose={() => setSelectedDiagnostico(null)}
          title="Editar Diagnostico"
        />
      )}
    </div>
  );
};

export default AddDiagnostico;
